import s from '../collegesItem.module.css'
import {useState} from "react";

import {Button} from "antd";
import {useAddAlert} from "@/hooks/useAddAlert";
import { usersAPI, directionAPI } from "@api"
import { useLoad } from "@/hooks/useLoad";
import { compareOptionsByLabel } from '@/helpers/new/compareOptionsByLabel';
import { filterOptionsByLabel } from '@/helpers/new/filterOptionsByLabel';
import Select from '@UI/New/Select';
import { useSelector } from 'react-redux';

const ModalAddDirection = ({userId, subjects, setActive, update}) => {
  const addAlert = useAddAlert();
  const [loading, setLoading] = useState(false);
  const settings = useSelector((store) => store.settings);
  const allowSameCourseInDifferentGroups =
    settings?.allowStudentToEnrollSameCourseInDifferentGroups === '1';


  const getParams = () => {
    if (!allowSameCourseInDifferentGroups && subjects?.length) {
      return {
        filter: [
          `[direction_id][nin][]=${subjects?.map(
            ({ id }) => id
          )}`,
        ],
      };
    }
    return;
  };

  const { state: directionList, loading: directionLoading } = useLoad({
    api: directionAPI.getAll,
    params: { ...getParams() },
    initState: [],
    key: "data",
  });

  const [direction, setDirection] = useState("");

  const fieldsDirection = {
      loading: directionLoading,
      showSearch: true,
      allowClear: false,
      filterSort: compareOptionsByLabel,
      filterOption: filterOptionsByLabel,
      onChange: setDirection,
      options: directionList
        ?.filter(({ id }) => !subjects?.some(
          ({ id: subjectId }) => String(subjectId) === String(id)
        ))
        .map(({ id: value, name: label }) => ({
          label,
          value,
        })),
      value: direction || null,
      placeholder: 'Выберите курс',
      notFoundContent: "Курсы не найдены"
  };

  const save = () => {
    if (direction) {
      setLoading(true)
      usersAPI
          .addDirection({
            data: { direction_id: direction, seminarian_id: userId },
          })
          .then((res) => {
            if (res.data.status === "success") {
              update("direction")
              addAlert({ title: "Курс успешно добавлен" });
              setActive(false)
            }
          })
          .finally((res)=>{
            setLoading(true);
          });
    } else {
      addAlert({ type: "error", title: "Не выбран курс" });
    }
  };
 
  return <div className="modal_departments">
    <h2 className="modal__title">Добавить курс</h2>
    <div className={s.body}>
        <span style={{fontSize:'12px', color:'var(--color-text-strong)', fontWeight:'400', marginBottom:'-10px'}}>Выберите курс</span>
        <Select
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsDirection} 
        />
        <Button disabled={loading} onClick={save}>Добавить</Button>
    </div>
  </div>
}
export default ModalAddDirection
